import { styled } from '@mui/material/styles';
import { Stack } from '@mui/material';

export const ItemRowStyled = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'isLast',
})<{ selected?: boolean; isLast?: boolean }>(({ theme, selected, isLast }) => ({
  position: 'relative',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  paddingInlineStart: 52,
  cursor: 'pointer',
  // Tree connector: vertical trunk aligned to the centre of the group checkbox.
  // On the last item it stops at the middle instead of the bottom.
  '&::before': {
    content: '""',
    position: 'absolute',
    insetInlineStart: 31,
    top: 0,
    bottom: isLast ? '50%' : 0,
    borderInlineStart: `1px solid ${theme.palette.divider}`,
  },
  // Tree connector: horizontal branch from the trunk to this item row.
  '&::after': {
    content: '""',
    position: 'absolute',
    insetInlineStart: 31,
    top: '50%',
    width: 12,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  ...(selected && {
    backgroundColor: theme.palette.success.light,
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.success.dark,
    }),
  }),
}));
